import React from "react"
import Table from "material-ui/Table"
import TableHeaderColumn from "material-ui/Table/TableHeaderColumn"
import TableRow from "material-ui/Table/TableRow"
import TableHeader from "material-ui/Table/TableHeader"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TableBody from "material-ui/Table/TableBody"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import HierarchyBreadCrumb from "./HierarchyBreadCrumb"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import AccountStore from "../../../stores/AccountStore"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as hierarchySettingsActions from "../../../actions/HierarchySettingsActions"
import { IHierarchyItem, IHierarchyItemForAccountLevel } from "../../../models"
import autobind from "class-autobind"
interface IProps {
	selectedHierarchy: IHierarchyItem
	clickableAccessHierarchies: string[]
	handleSelectHierarchyItem(selectedLevel: IHierarchyItem | IHierarchyItemForAccountLevel): void
}
interface IState {
	levelId: string
	searchText: string
	showTableActionBar: boolean
}
const styles = {
	columnValue: {
		textAlign: "left",
		cursor: "pointer"
	},
	columnNameValue: {
		textAlign: "left",
		cursor: "pointer",
		width: 200
	},	
	columnHeader: {
		textAlign: "left"
	},
	_padding: { padding: 35 },
	_float: { float: "left" },
	clear: { clear: "both" },
	empty: { textAlign: "center", marginTop: 50, marginBottom: 50 }
}

export default class ChooseHierarchyPicker extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			levelId: null,
			searchText: "",
			showTableActionBar: true,
		}
		autobind(this)
	}

	getFilteredHierarchyItemsBySearchText(): IHierarchyItem[] {
		return this.state.searchText.trim() ?
			AccountStore.getCurrentAccount().HierarchyItems.slice().filter(item =>
				(item.Label && item.Label.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1) ||
				(item.CostCenter && item.CostCenter.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1)
			) :
			hierarchyHelper.getChildHierarchyItems(HierarchySettingsStore.getSelectedLevelItem() ? HierarchySettingsStore.getSelectedLevelItem().Id : null)
	}

	filterByClickableAccessHierarchies(hierarchyItems: IHierarchyItem[], clickableAccessHierarchyIds: string[]): IHierarchyItem[] {
		return hierarchyItems.filter(item => clickableAccessHierarchyIds.includes(item.Id ? item.Id : null))
	}

	render() {
		const hierarchyItems = this.filterByClickableAccessHierarchies(this.getFilteredHierarchyItemsBySearchText(), this.props.clickableAccessHierarchies)
		const hierarchyHasChildHierarchy = HierarchySettingsStore.checkHierarchyHasChildHierarchy(this.props.selectedHierarchy ? this.props.selectedHierarchy.Id : null)
		return (
			<div>
				<div style={styles._padding}>
					<div style={styles._float}>
						<HierarchyBreadCrumb
							handleSelectHierarchyItem={this.props.handleSelectHierarchyItem}
							clickableAccessHierarchies={this.props.clickableAccessHierarchies}
						/>
					</div>
					<div style={styles.clear} />
					{this.state.showTableActionBar && hierarchyHasChildHierarchy &&
						<TableActionBar
							onSearch={searchText => this.setState({ searchText })}
							searchText={this.state.searchText}
							rowSelectionCount={0}
						/>
					}
					{(hierarchyHasChildHierarchy || this.state.searchText.trim()) &&
						<div>
							{!hierarchyItems.length ?
								<div>
									<h2 style={styles.empty}>{strings.No_hierarchy_found}</h2>
								</div> :
								<Table
									multiSelectable={false}
									selectable={false}
									onCellClick={rowNumber => {
										const parentLabel = hierarchyHelper.getFullPathLabel(hierarchyItems[rowNumber].ParentId)
										if (parentLabel !== strings.Hierarchy_Removed) {
											hierarchySettingsActions.receiveHierarchySelectedItem(hierarchyItems[rowNumber])
											this.setState({ searchText: "", showTableActionBar: false }, () => this.setState({ showTableActionBar: true }))
											this.props.handleSelectHierarchyItem(hierarchyItems[rowNumber])
										}
									}}
								>
									<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
										<TableRow>
											<TableHeaderColumn style={styles.columnNameValue}>{strings.Name}</TableHeaderColumn>
											<TableHeaderColumn>{strings.HierarchyLevel}</TableHeaderColumn>
											<TableHeaderColumn>{strings.CostCenter}</TableHeaderColumn>
											<TableHeaderColumn>{strings.Parent_Hierarchy}</TableHeaderColumn>
										</TableRow>
									</TableHeader>
									<TableBody showRowHover deselectOnClickaway={false} displayRowCheckbox={false}>
										{hierarchyItems.map((row, i) => {
												const parentLabel = hierarchyHelper.getFullPathLabel(row.ParentId)
											const isDisabled = parentLabel === strings.Hierarchy_Removed
											return (
											<TableRow key={i} style={isDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}>
												<TableRowColumn style={styles.columnNameValue}>{row.Label}</TableRowColumn>
												<TableRowColumn style={styles.columnValue}>{hierarchyHelper.getHierarchyDefinitionNameByHierarchyDefinitionId(row.HierarchyDefinitionId)}</TableRowColumn>
												<TableRowColumn style={styles.columnValue}>{row.CostCenter}</TableRowColumn>
												<TableRowColumn style={styles.columnValue} title={parentLabel}>{parentLabel}</TableRowColumn>												</TableRow>
										)
										})}
									</TableBody>
								</Table>
							}
						</div>
					}
				</div>
			</div>
		)
	}
}
